// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AlternatePeoplePicker_wrapper__jgAFb"};